export const STORAGE_MODE_BUTTON_VISIBLE_KEY = 'translations-mode:visible';
export const STORAGE_MODE_ENABLED_KEY = 'translations-mode:enabled';
export const STORAGE_RTL_MODE_KEY = 'rtl-mode:enabled';
export const STORAGE_ANALYTICS_DEBUG_KEY = 'analytics-debug:enabled';
